import { mapActions, mapGetters } from 'vuex'
import { SubjectTypes } from '@/core/utils'

export const ClassroomMixins = {
  computed: {
    ...mapGetters({
      classroom: 'ClassroomModule/classroom'
    }),
    isIndependentClassroom () {
      const independentSubjects = [
        SubjectTypes.independentBasic.type,
        SubjectTypes.independentLanguage.type,
        SubjectTypes.independentPlayersTrust.type
      ]
      return independentSubjects.includes(this.classroom.subject.type)
    }
  },
  methods: {
    ...mapActions({
      getClassroom: 'ClassroomModule/getClassroom'
    })
  }
}
